export default "__VITE_ASSET__667JomZx__"